import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const app = firebase.initializeApp({
  apiKey: "AIzaSyBrPUYSD3MygAodZCfUJQRYtFwEPLaVuQo",
  authDomain: "usport-95229.firebaseapp.com",
  projectId: "usport-95229",
  storageBucket: "usport-95229.appspot.com",
  messagingSenderId: "903903430571",
  appId: "1:903903430571:web:295291826614b51e99f4ee",
  measurementId: "G-4SD5F8CTTL"
})

export const auth = app.auth();
export const db = app.firestore();
export const increment = firebase.firestore.FieldValue.increment(1);
export default app